import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <p>
        <Link to="/">Home</Link> |
        <Link to="/about"> About Us</Link> |
        <Link to="/contact"> Contact Us</Link> |
        <Link to="/order-lookup"> Find your order</Link> |
        <Link to="/cart"> Cart</Link>
      </p>
      <p>© {new Date().getFullYear()} Aquaviva Foods (UK) Ltd — <i>Designed and managed by Olifett Ltd</i></p>
    </footer>
  );
}